import { render, staticRenderFns } from "./QuestionPay.vue?vue&type=template&id=8f5e7a02&scoped=true&"
import script from "./QuestionPay.vue?vue&type=script&lang=js&"
export * from "./QuestionPay.vue?vue&type=script&lang=js&"
import style0 from "./QuestionPay.vue?vue&type=style&index=0&id=8f5e7a02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f5e7a02",
  null
  
)

export default component.exports